import React, { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import { getPairChartData } from "../Service/data";
import Chart from "../Charts/Chart";
import ErrorBoundary from "./ErrorBoundry";
import { useSearchParams } from "react-router-dom";
import CompareChart from "../Charts/CompareChart";

const StockCompareChart = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();
  const [showRsi, setShowRsi] = useState(false);
  const [showMacd, setShowMacd] = useState(false);
  const [showAdx, setShowAdx] = useState(false);
  const [showRoc, setShowRoc] = useState(false);
  const [showBB, setShowBB] = useState(false);

  useEffect(() => {
    let params = new URLSearchParams(searchParams);

    const rsi = params.get('showRsi');
    setShowRsi(rsi);

    const macd = params.get('showMacd');
    setShowMacd(macd);

    const adx = params.get('showAdx');
    setShowAdx(adx);

    const roc = params.get('showRoc');
    setShowRoc(roc);

    const bb = params.get('showBB');
    setShowBB(bb);


  }, [searchParams]);


  useEffect(() => {
    setLoading(true);
    setNoData(true);
    let time = "1";
    if (props.time !== undefined) {
      console.log('here');
      time = props.time;
    }
    const fetchData = async () => {
      try {
        getPairChartData(props.symbol1, props.symbol2, time).then((data) => {
          console.log(props.symbol);
          setData(data);
          setLoading(false);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [props.symbol1, props.symbol2]);

  // useEffect(()=>{
  //   console.log("changed");
  //   setLoading(true);
  // }, [props.symbol])

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      // setLoading(false);\
      console.log(data);
      setNoData(false);
    }
  }, [data]);

  return (
    <div>
      {loading && <CircularProgress />}
      {noData ? (
        <Typography>No data was received</Typography>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <ErrorBoundary>
            <Typography component="h1" color={"white"}>{props.title}</Typography>
            <CompareChart
              title={props.symbol}
              width={props.width}
              height={props.height}
              data={data}
              symbol1={props.symbol1}
              symbol2={props.symbol2}
              comparekey1={`Close_${props.symbol1}`}
              comparekey2={`Close_${props.symbol2}`}
              rsi={showRsi}
              macd={showMacd}
              adx={showAdx}
              roc={showRoc}
              bb={showBB}
            ></CompareChart>
          </ErrorBoundary>
          <div></div>
        </div>
      )}
    </div>
  );
};

export default StockCompareChart;
